import { createRoot, type Root } from 'react-dom/client';
import './index.css';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import ErrorFallback from './components/errorFallback.tsx';
import { createApplicationContainer, createWebComponent, type TRootNode } from './packager';

const renderApplication = async (
  rootNode: TRootNode<Root>,
  node: HTMLElement,
  params: Record<string, string>,
  onReady: () => void,
) => {
  const root = createRoot(node);

  root.render(
    <ErrorBoundary
      FallbackComponent={ErrorFallback}>
      <App {...params} />
    </ErrorBoundary>,
  );
  rootNode.applicationNode = root;

  if (window.requestIdleCallback) {
    window.requestIdleCallback(onReady);
  } else {
    // Safari doesn't support requestIdleCallback
    // https://caniuse.com/requestidlecallback
    window.setTimeout(onReady, 1);
  }

};

createWebComponent<Root>(
  'fabric-registration-v2',
  (root, attributes, onReady) => {
    root.id = 'fabric-registration-v2';
    Promise.all([createApplicationContainer(root)]).then(([container]) =>
      renderApplication(root, container, attributes, onReady),
    );
  },
  (node) => {
    node?.applicationNode?.unmount();
  },
);
